import { INVOICES_FETCH, SET_REPORTS_FILTER } from './types';

export default {
  [INVOICES_FETCH](state, payload) {
    const { data, pagination } = payload;
    state.invoices.invoices = data;
    state.invoices.pagination = pagination;
  },
  [SET_REPORTS_FILTER](state, payload) {
    state.filters = {
      ...state.filters,
      ...payload,
    };
  },
};
